$(function()  {
    // Selecting the tabbed schedule container
    const $tabbedSchedule = $('.tabbed-schedule');


    // Function to show a tab
    const showTab = tabNumber => {
        const $matchingElement = $tabbedSchedule.find(`.row.${tabNumber}`).toggleClass('active', true).show().siblings().removeClass('active').hide();
    };

    $tabbedSchedule.on('click', '.schedule-tabs li a', function (e) {
        e.preventDefault();

        // Highlighting the clicked tab and hiding others
        $(this).addClass('active').parent().siblings().find('a').removeClass('active');
        showTab($(this).attr('href').slice(1));
    });

    // Triggering a click on the first tab to set it as active by default
    $('.schedule-tabs li:first-child a').trigger('click');

    // Function to smooth scroll to a specific class within the active tab
    const smoothScrollToClass = className => {
        const $activeRow = $tabbedSchedule.find('.row.active');

        if ($activeRow.length) {
            const $targetElement = className ? $activeRow.find(`.${className}`) : $activeRow.find('.schedule-announcement');

            if ($targetElement.length) {
                const navbarHeight = $('#NAV').outerHeight() || 0;
                const targetOffset = $targetElement.offset().top - navbarHeight;
                $('html, body').stop().animate({ 'scrollTop': targetOffset }, 900, 'swing');
            }
        }
    };

    // Event handler for clicking on links within the announcement section
    $tabbedSchedule.on('click', '.ContentItemHtml.schedule-announcement ul li a', e => {
        e.preventDefault();
        smoothScrollToClass($(e.target).attr('href').slice(1));
    });

    // Scroll to top of tabbed-schedule section when Back to Top link is clicked
    function scrollBacktoTop() {
        const $container = $('.tabbed-schedule');
        const navbarHeight = $('#NAV').outerHeight() || 0;

        if ($container.length) {
            $('html, body').animate(
                { scrollTop: $container.offset().top - navbarHeight },
                700
            );
        }
    }
    // Expose globally so inline onclick="scrollBacktoTop()" works
    window.scrollBacktoTop = scrollBacktoTop;

});